/**
 * ****************************************************************************
 * @description     :   Store menu
 * @created at      :   2024/10/11
 * @created by      :   ANS376 – daonx@ans-net.co.jp
 * @package         :   Move version 2
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */

// import repository from './repository';

const dataPreviewInit = {
    listMenu: {
        APP: {
            list: [
                {
                    name: 'APP_System001',
                    to: '',
                    class: '',
                    title: 'TOP'
                },
                {
                    name: 'APP_WorkReport001',
                    to: '/APP_WorkReport001',
                    class: '',
                    title: '業務日報一覧'
                },
                {
                    name: 'APP_SalesReport001',
                    to: '/APP_SalesReport001',
                    class: '',
                    title: '営業報告一覧'
                }
            ]
        }
    }
};
export default {
    namespaced: true,
    state: {
        listMenu: { ...dataPreviewInit.listMenu.APP }
    },
    mutations: {
        resetDataInit(state) {
            state.data = { ...dataPreviewInit };
        },
        setListMenuLeft(state, newData) {
            state.listMenu = newData;
        }
    },
    actions: {
        async fetchMenuLeft(context, page) {
            try {
                const responseItems = await new Promise((resolve) => {
                    resolve({
                        ...dataPreviewInit.listMenu[page]
                    });
                });
                context.commit('setListMenuLeft', responseItems);
            } catch (e) {
                console.log('fetchMenuLeft: ' + e.message);
            }
        }
    }
};
